module.exports = __webpack_public_path__ + "static/video-hosting-8cf7b09c5e2c2279e1c7809d02269cad.webp";